import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { settingsIntegrationsCardsCustomRoutes } from './views/custom';
import { settingsIntegrationsCardsMagentoRoutes } from './views/magento';
import { settingsIntegrationsCardsSalesforceRoutes } from './views/salesforce';
import { settingsIntegrationsCardsShopifyRoutes } from './views/shopify';
export const settingsIntegrationsCardsRoutes = (_jsxs(Fragment, { children: [settingsIntegrationsCardsCustomRoutes, settingsIntegrationsCardsShopifyRoutes, settingsIntegrationsCardsMagentoRoutes, settingsIntegrationsCardsSalesforceRoutes] }));
